/** The deck tile whose alley corner came out with Otto's broken wall. */
import * as THREE from 'three';
import { surface } from '../materials';
import type { AssetDefinition } from '../types';

const TILE = 1.2;
const GAP = 0.018;
const SLAT_WIDTH = (TILE - 10 * GAP) / 10;
/** The missing threshold is one quarter-tile: the deck begins 0.30 m inside. */
export const BROKEN_DECK_THRESHOLD = 0.3;
/** Shift from the original tile centre to the remaining slab's own centre. */
export const BROKEN_DECK_REMAINDER_CENTER = BROKEN_DECK_THRESHOLD / 2;

function build(): THREE.Group {
  const group = new THREE.Group();
  group.name = 'slat-floor-broken';
  const concrete = surface('mineral', 0x818984);
  const brokenEdge = -TILE / 2 + BROKEN_DECK_THRESHOLD;
  // Keep the original 18 mm cadence, then cut the one crossing slat at the
  // same authored edge the collision shell uses. Omitting it whole made the
  // picture's recess 51 mm deeper than the 0.30 m physical threshold.
  for (let i = 0; i < 10; i++) {
    const slatMin = -TILE / 2 + GAP / 2 + i * (SLAT_WIDTH + GAP);
    const slatMax = slatMin + SLAT_WIDTH;
    const keptMin = Math.max(slatMin, brokenEdge);
    if (keptMin >= slatMax) continue;
    const slat = new THREE.Mesh(new THREE.BoxGeometry(slatMax - keptMin, 0.09, TILE), concrete);
    slat.position.set((keptMin + slatMax) / 2 - BROKEN_DECK_REMAINDER_CENTER, 0.045, 0);
    slat.name = `broken-slat-${String(i)}`;
    slat.receiveShadow = true;
    group.add(slat);
  }
  return group;
}

export const slatFloorBrokenAsset: AssetDefinition = {
  id: 'slat-floor-broken', label: 'Broken slat floor',
  description: '0.90 m slatted deck remainder after Otto’s 0.30 m alley corner broke away.',
  footprint: { width: TILE - BROKEN_DECK_THRESHOLD, height: 0.09, length: TILE }, create: build,
};
